<div class="ss-trigger-container">
  <!-- Pre-configured Prompts Section -->
  @if (promptService.prompts().length > 0) {
    <div class="prompts-section" #promptsSection>
      <h3 class="section-title">
        {{ 'search.smart-search-panel.last-used-prompts' | translate }}
      </h3>
      <div class="prompts-list-wrapper">
        <div class="prompts-list" #promptsList>
          @for (prompt of promptService.prompts().slice(0, maxVisiblePrompts); track prompt) {
            <ex-button data-cy="smart-search-prompt" class="prompt-button" type="secondary" variant="raised" (click)="selectPrompt(prompt)">
              <div class="prompt-button-content" [style.width]="prompt.user_id ? title.scrollWidth + 28 + 'px' : undefined">
                @if (prompt.user_id) {
                  <i class="ph-fill ph-user-circle"></i>
                }
                <span #title class="prompt-title">{{ prompt.title }}</span>
                @if (prompt.user_id) {
                  <i
                    class="ph-fill ph-gear-six edit-prompt-icon"
                    [ngbTooltip]="'common.edit' | translate"
                    tooltipClass="simple-tooltip fit"
                    placement="top auto"
                    container="body"
                    (click)="$event.stopPropagation(); editPrompt(prompt)"
                  ></i>
                }
              </div>
            </ex-button>
          }
          @if (hasMorePrompts()) {
            <div class="see-more-container" #seeMoreContainer>
              <ex-button class="see-more-button" icon="plus" (click)="toggleSeeMoreDropdown($event)">
                {{ 'search.smart-search-panel.see-more' | translate }}
              </ex-button>
            </div>
          }
        </div>
      </div>
      @if (hasMorePrompts() && showSeeMoreDropdown) {
        <div class="see-more-dropdown" [style.top]="dropdownTop" [style.right]="dropdownRight">
          @for (prompt of hiddenPrompts(); track prompt) {
            <ex-button class="prompt-button" (click)="selectPrompt(prompt); showSeeMoreDropdown = false" type="primary" variant="ghost">
              <div class="prompt-button-content max">
                @if (prompt.user_id) {
                  <i class="ph-fill ph-user-circle"></i>
                }
                <span class="prompt-title">{{ prompt.title }}</span>
                @if (prompt.user_id) {
                  <i
                    class="ph-fill ph-gear-six edit-prompt-icon ms-auto"
                    [ngbTooltip]="'common.edit' | translate"
                    tooltipClass="simple-tooltip fit"
                    placement="top auto"
                    (click)="$event.stopPropagation(); editPrompt(prompt)"
                  ></i>
                }
              </div>
            </ex-button>
          }
        </div>
      }
    </div>
  }
  <app-smart-search-prompt [prompt]="selectedPrompt?.text" (promptChange)="onPromptTextChange($event)" />

  <!-- Footer -->
  <div class="ss-trigger-footer">
    <div class="document-types-selection">
      <div class="icon-wrapper">
        <ex-button
          data-cy="smart-search-source-press"
          (click)="toggleSourceStatus(SmartSearchSource.PRESS)"
          icon="newspaper-fill"
          variant="ghost"
          class="filter-btn"
          [ngClass]="{ 'greyed-out': !selectedSources[SmartSearchSource.PRESS] }"
        >
          {{ 'search.smart-search-panel.press' | translate }}
        </ex-button>
        @if (selectedSources[SmartSearchSource.PRESS]) {
          <mat-icon class="ph ph-check-circle ph-fill active-badge"></mat-icon>
        }
      </div>

      @if (!searchConfig.impacterId) {
        <div class="icon-wrapper">
          <ex-button
            (click)="toggleSourceStatus(SmartSearchSource.ADMIN_DOC)"
            iconSrc="assets/images/admin-doc-filled.svg"
            variant="ghost"
            class="filter-btn"
            [ngClass]="{
              'greyed-out': !selectedSources[SmartSearchSource.ADMIN_DOC],
            }"
          >
            {{ 'search.smart-search-panel.admin-publications' | translate }}
          </ex-button>
          @if (selectedSources[SmartSearchSource.ADMIN_DOC]) {
            <mat-icon class="ph ph-check-circle ph-fill active-badge"></mat-icon>
          }
        </div>
      }

      <div class="icon-wrapper">
        <ex-button
          (click)="toggleSourceStatus(SmartSearchSource.WEB)"
          icon="globe"
          variant="ghost"
          class="filter-btn"
          [ngClass]="{
            'greyed-out': !selectedSources[SmartSearchSource.WEB],
          }"
        >
          {{ 'search.smart-search-panel.web' | translate }}
        </ex-button>
        @if (selectedSources[SmartSearchSource.WEB]) {
          <mat-icon class="ph ph-check-circle ph-fill active-badge"></mat-icon>
        }
      </div>
    </div>
    <ex-button
      data-cy="smart-search-launch"
      size="x-large"
      (click)="TriggerSmartSearch()"
      icon="shooting-star"
      [disabled]="!canTriggerSmartSearch()"
      #launchButtonTooltip="ngbTooltip"
      [ngbTooltip]="getTooltipMessage() | translate"
      tooltipClass="simple-tooltip max-m"
      container="body"
      placement="top"
      triggers="hover focus"
      [openDelay]="0"
      [closeDelay]="0"
      [disableTooltip]="!shouldShowTooltip()"
    >
      {{ 'search.smart-search-panel.launch-analysis' | translate }}
    </ex-button>
  </div>
</div>
